import moment from 'moment';
import React, { useState } from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { connect } from 'react-redux';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import celebrating from '../../assets/images/celebrating.png';
import defaultBgPattern from '../../assets/static/default_bg.png';
import defaultBgLoyaltyPattern from '../../assets/static/default_bg_loyalty.png';
import CONSTANTS from '../../constants';
import ImageHelper from '../../helpers/ImageHelper';
import TimeHelper from '../../helpers/TimeHelper';
import ViewHelper from '../../helpers/ViewHelper';
import RewardItemsModal from '../loyalty/RewardItemsModal';
import withBackButtonHandled from '../shared/WithBackButtonHandled';

const PromotionalItems = (props) => {
  const [rewardItemsModal, setRewardItemsModal] = useState(false);
  const [currentRewardData, setCurrentRewardData] = useState([]);
  const getCurrentWidthViewPer = (width) => {
    if (width <= 450) {
      return 1.2;
    } else if (width <= 991) {
      return 2;
    } else {
      return 3;
    }
  };

  const getCurrentWidthSpaceBetween = (width) => {
    if (width <= 768) {
      return 14;
    } else {
      return 25;
    }
  };
  const promotionTitles =
    props.promotions && props._location
      ? ViewHelper.getCustomizedPromotionTitles(props.promotions, props._location)
      : [];

  const toggleRewardItemsModal = (rewardLevelData) => {
    setCurrentRewardData(rewardLevelData);
    setRewardItemsModal(!rewardItemsModal);
  }

  const getDefaultTitleAndSubTitle = (promo_code) => {
    let promo_code_titles = {};
    let splited_promo;
    for (const promo_title of promotionTitles) {
      splited_promo = promo_title.split(':');
      if (splited_promo[0] === promo_code) {
        promo_code_titles.title = splited_promo[0];
        promo_code_titles.sub_title = splited_promo[1];
      }
    }
    return promo_code_titles;
  };
  const promotionsList = [];
  if (props.promotions?.basket.length > 0) {
    for (const basketPromo of props.promotions.basket) {
      promotionsList.push(basketPromo);
    }
  }

  if (props.promotions?.all_items.length > 0) {
    props.promotions.all_items.map((allItemPromo) => {
      promotionsList.push(allItemPromo);
    });
  }

  if (props.promotions) {
    const catKeys = Object.keys(
      props.promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES]
    );
    if (catKeys.length > 0) {
      const catObj = props.promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
      let temp_promo_id = '';
      catKeys.map((categoryPromo, index) => {
        const prom = catObj[parseInt(catKeys[index])];
        if (temp_promo_id !== prom.promotion_discount_id) {
          promotionsList.push(prom);
          temp_promo_id = prom.promotion_discount_id;
        }
      });
    }
  }
  if (props.promotions) {
    const itemKeys = Object.keys(
      props.promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length > 0) {
      const catObj = props.promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
      let temp_promo_id = '';
      itemKeys.map((itemPromo, index) => {
        const prom = catObj[parseInt(itemKeys[index])];
        if (temp_promo_id !== prom.promotion_discount_id) {
          promotionsList.push(prom);
          temp_promo_id = prom.promotion_discount_id;
        }
      });
    }
  }
  const items = (rewards) => {
    let itemsData = []
    for (let i = 0; i < rewards.length; i++) {
      let reward = rewards[i];
      itemsData.push(reward.Menu.menu_name);
    }
    let itemString = itemsData.toString();
    if (itemsData.length === 1) {
      return 'Free ' + itemString;
    } else {
      return 'Free Selected Items';
    }
  }

  const getActiveRewardLevel = (rewardLevels) => {
    let reward = '';
    for (let i = 0; i < rewardLevels.length; i++) {
      let rewardLevel = rewardLevels[i];
      if (rewardLevel.EarnedReward)
        continue;
      reward = rewardLevel;
      break;
    }
    if (reward) {
      return reward;
    } else {
      return rewardLevels[0];
    }
  }


  const recentCompletedStats = (loyalty, rewardLevels) => {
    let stats = [];
    let totalActions = 0;
    if (rewardLevels.length === 0)
      return [];
    for (let i = 0; i < rewardLevels.length; i++) {
      let rewardLevel = rewardLevels[i];
      totalActions = totalActions + rewardLevel.action;
      if (loyalty.LoyaltyHistories.length > 0) {
        for (let j = 0; j < loyalty.LoyaltyHistories.length; j++) {
          let loyaltyHistory = loyalty.LoyaltyHistories[j];
          if (loyaltyHistory.program_type === 1 && loyaltyHistory.reward_id === rewardLevel.reward_id && loyaltyHistory.reward_level_id === rewardLevel.id) {
            stats.push(loyaltyHistory);
          }
          if (loyaltyHistory.program_type === 0 && loyaltyHistory.order_amount > rewardLevel.action && loyaltyHistory.reward_id === rewardLevel.reward_id && loyaltyHistory.reward_level_id === rewardLevel.id) {
            stats.push(loyaltyHistory);
          }
        }
      }

    }
    return { totalActions, stats };
  }

  const getSpendProgress = (loyalty, rewardLevels) => {
    let totalActions = 0;
    if (rewardLevels.length === 0)
      return [];
    for (let i = 0; i < rewardLevels.length; i++) {
      let rewardLevel = rewardLevels[i];
      if (loyalty.LoyaltyHistories.length > 0) {
        for (let j = 0; j < loyalty.LoyaltyHistories.length; j++) {
          let loyaltyHistory = loyalty.LoyaltyHistories[j];
          if (loyaltyHistory.program_type === 0 && loyaltyHistory.order_amount > rewardLevel.action && loyaltyHistory.reward_id === rewardLevel.reward_id && loyaltyHistory.reward_level_id === rewardLevel.id) {
            totalActions = totalActions + rewardLevel.action;
          }
        }
      }
    }
    return totalActions;
  }

  const calculateDaysRemaining = (expirationDate) => {
    const currentDate = moment();
    const expiration = moment(expirationDate);
    const diffInDays = expiration.diff(currentDate, 'days');
    const diffHours = expiration.diff(currentDate, 'hours');
    const diffMinutes = expiration.diff(currentDate, 'minutes');
    const diffSeconds = expiration.diff(currentDate, 'seconds');
    if (diffInDays > 0) {

      return diffInDays === 1 ? diffInDays + ' Day' : diffInDays + ' Days';
    } else if (diffHours > 0) {
      return diffHours === 1 ? diffHours + ' hour' : diffHours + ' hours';
    } else if (diffMinutes > 0) {
      return diffMinutes === 1 ? diffMinutes + ' minute' : diffMinutes + ' minutes';
    } else {
      return diffSeconds === 1 ? diffSeconds + ' second' : diffSeconds + ' seconds';
    }
  };

  const getSpendSum = (loyaltyHistories) => {
    let sumAcc = 0
    if (loyaltyHistories.length > 0) {
      for (let i = 0; i < loyaltyHistories.length; i++) {
        sumAcc += loyaltyHistories[i].order_amount;
      }
    }
    return sumAcc;
  }

  const goToRewardPage = () => {
    return props.history.push('/earned')
  }

  return (
    <>
      {rewardItemsModal ?
        <RewardItemsModal
          toggleModal={toggleRewardItemsModal}
          showModal={rewardItemsModal}
          currentRewardData={currentRewardData}
        />
        : ''
      }
      {promotionsList?.length > 0 && props._loyalties?.length === 0 && (
        <>
          <h4 class="f1 mb-2 custom-deals-name primary-font-color">PROMOS & REWARDS</h4>
          <div
            className={
              props.category_length === 1
                ? 'promotional-items promotional-item-without-category'
                : 'promotional-items'
            }
          >
            <Swiper
              // style={{display:"none"}}
              pagination={{
                clickable: true
              }}
              modules={promotionsList.length > 3 && [Pagination]}
              // breakpoints={promotionalBreakpoints}
              spaceBetween={getCurrentWidthSpaceBetween(props.currentWidth)}
              slidesPerView={getCurrentWidthViewPer(props.currentWidth)}
            >

              {/* <SwiperSlide>
                <div className={`promotional-items__card default-bg`}>
                  <img
                    src={defaultBgPattern}
                    alt=""
                  />

                  <div className="promotional-items__contents">
                    <div className="promotional-items__contents__data">
                      <h2 className={'promotional-items__contents__data__title'}>
                        Upcoming Reward
                      </h2>
                      <h3 className={'promotional-items__contents__data__sub-title'}>
                        Complete 1  Visit with minim amount of order 1000
                      </h3>
                    </div>
                  </div>
                </div>
              </SwiperSlide> */}
              {promotionsList.map((promotion) => {
                return (
                  <SwiperSlide>
                    {promotion.promotion_banner_type === 'none' ? (
                      <div
                        className={
                          promotion.promotion_banner_img_url === null ||
                            promotion.promotion_banner_img_url === ''
                            ? `promotional-items__card default-bg hovernowshodow`
                            : 'promotional-items__card hovernowshodow'
                        }
                        key={promotion.id}
                      >
                        <img
                          src={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? defaultBgPattern
                              : ImageHelper.getImageURL(
                                promotion.promotion_banner_img_url,
                                '?func=crop&w=400&h=300'
                              )
                          }
                          alt=""
                        />
                      </div>
                    ) : promotion.promotion_banner_type === 'custom' ? (
                      <div
                        className={
                          promotion.promotion_banner_img_url === null ||
                            promotion.promotion_banner_img_url === ''
                            ? `promotional-items__card default-bg hovernowshodow`
                            : 'promotional-items__card hovernowshodow'
                        }
                        key={promotion.id}
                      >
                        <img
                          src={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? defaultBgPattern
                              : ImageHelper.getImageURL(
                                promotion.promotion_banner_img_url,
                                '?func=crop&w=400&h=300'
                              )
                          }
                          alt=""
                        />
                        <div className="promotional-items__contents">
                          <div className="promotional-items__contents__data">
                            <h2 className={'promotional-items__contents__data__title'}>
                              {promotion.promotion_banner_title}
                            </h2>
                            <h3 className={'promotional-items__contents__data__sub-title'}>
                              {promotion.promotion_banner_sub_title}
                            </h3>
                          </div>
                        </div>
                      </div>
                    ) : promotion.promotion_banner_type === 'default' ? (
                      getDefaultTitleAndSubTitle(promotion.code.toUpperCase()).title ? (
                        <div
                          className={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? `promotional-items__card default-bg hovernowshodow`
                              : 'promotional-items__card hovernowshodow'
                          }
                          key={promotion.id}
                        >
                          <img
                            src={
                              promotion.promotion_banner_img_url === null ||
                                promotion.promotion_banner_img_url === ''
                                ? defaultBgPattern
                                : ImageHelper.getImageURL(
                                  promotion.promotion_banner_img_url,
                                  '?func=crop&w=400&h=300'
                                )
                            }
                            alt=""
                          />
                          <div className="promotional-items__contents">
                            <div className="promotional-items__contents__data">
                              <h2 className={'promotional-items__contents__data__title'}>
                                {getDefaultTitleAndSubTitle(promotion.code.toUpperCase()).title}
                              </h2>
                              <h3 className={'promotional-items__contents__data__sub-title'}>
                                {getDefaultTitleAndSubTitle(promotion.code.toUpperCase()).sub_title}
                              </h3>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ''
                      )
                    ) : (
                      <div
                        className={
                          promotion.promotion_banner_img_url === null ||
                            promotion.promotion_banner_img_url === ''
                            ? `promotional-items__card default-bg hovernowshodow`
                            : 'promotional-items__card hovernowshodow'
                        }
                        key={promotion.id}
                      >
                        <img
                          src={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? defaultBgPattern
                              : ImageHelper.getImageURL(
                                promotion.promotion_banner_img_url,
                                '?func=crop&w=400&h=300'
                              )
                          }
                          alt=""
                        />
                        <div className="promotional-items__contents">
                          <div className="promotional-items__contents__data">
                            <h2 className={'promotional-items__contents__data__title'}>
                              {promotion.promotion_banner_title}
                            </h2>
                            <h3 className={'promotional-items__contents__data__sub-title'}>
                              {promotion.promotion_banner_sub_title}
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </>
      )}
      {promotionsList?.length > 0 && props._loyalties?.length > 0 && (
        <>
          <h4 class="f1 mb-2 custom-deals-name">PROMOS & REWARDS</h4>
          <div
            className={
              props.category_length === 1
                ? 'promotional-items promotional-item-without-category'
                : 'promotional-items '
            }
          >
            <Swiper
              // style={{display:"none"}}
              pagination={{
                clickable: true
              }}
              modules={promotionsList.length > 3 && [Pagination]}
              // breakpoints={promotionalBreakpoints}
              spaceBetween={getCurrentWidthSpaceBetween(props.currentWidth)}
              slidesPerView={getCurrentWidthViewPer(props.currentWidth)}
            >
              {props._loyalties.map((it, index) => {
                let loyaltyStats = recentCompletedStats(it, it.Reward.RewardLevels);
                let progress = it.loyalty_type === 1 ? loyaltyStats.stats.length / loyaltyStats.totalActions * 100 : loyaltyStats.stats.length !== 0 ? getSpendProgress(it, it.Reward.RewardLevels) / loyaltyStats.totalActions * 100 : 0;
                if (it.loyalty_type === 1 && it.Reward.reward_type === 0) {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);

                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b> Complete {activeRewardLevel.action} {activeRewardLevel.action === 1 ? 'visit' : 'visits'} {it.min_time_gap > 0 ? 'with ' + it.min_time_gap + ' hour interval' : ''}  </b> and get <a style={{ cursor: 'pointer' }} onClick={() => toggleRewardItemsModal(activeRewardLevel.RewardLevelData)}>{items(activeRewardLevel.RewardLevelData)}</a>
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>


                        </div>
                        <div className='d-flex flex-column justify-content-center m-2' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.stats.length}</strong> out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.totalActions === 1 ? loyaltyStats.totalActions + ' Visit' : loyaltyStats.totalActions + ' Visits'}</strong>
                              </div>
                            </CircularProgressbarWithChildren>

                          }
                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"

                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :
                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'

                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )

                } else if (it.loyalty_type === 1 && it.Reward.reward_type === 1) {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);
                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b> Complete {activeRewardLevel.action} {activeRewardLevel.action === 1 ? 'visit' : 'visits'} {it.min_time_gap > 0 ? 'with ' + it.min_time_gap + ' hour interval' : ''}  </b> and get {activeRewardLevel.RewardLevelData[0].discount}% discount voucher
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>


                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.stats.length}</strong> out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.totalActions === 1 ? loyaltyStats.totalActions + ' Visit' : loyaltyStats.totalActions + ' Visits'}</strong>
                              </div>
                            </CircularProgressbarWithChildren>
                          }


                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"

                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :

                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'

                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )

                } else if (it.loyalty_type === 0 && it.Reward.reward_type === 1) {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);

                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b>Spend {ViewHelper.toCurrencyWithNoDecimal(activeRewardLevel.action, props._location.currency)} </b> and get {activeRewardLevel.RewardLevelData[0].discount}% discount voucher
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>
                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(getSpendProgress(it, it.Reward.RewardLevels), props._location.currency)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(loyaltyStats.totalActions, props._location.currency)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                Spend
                              </div>
                            </CircularProgressbarWithChildren>
                          }


                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"

                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :
                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'

                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )

                } else {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);
                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b>Spend {ViewHelper.toCurrencyWithNoDecimal(activeRewardLevel.action, props._location.currency, 0)} </b> and get {items(activeRewardLevel.RewardLevelData)}
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>
                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(getSpendProgress(it, it.Reward.RewardLevels), props._location.currency, 0)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(loyaltyStats.totalActions, props._location.currency, 0)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                Spent
                              </div>
                            </CircularProgressbarWithChildren>
                          }


                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"

                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :

                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'

                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )
                }
              })
              }
              {
                promotionsList.map((promotion) => {
                  return (
                    <SwiperSlide>
                      {promotion.promotion_banner_type === 'none' ? (
                        <div
                          className={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? `promotional-items__card default-bg hovernowshodow`
                              : 'promotional-items__card hovernowshodow'
                          }
                          key={promotion.id}
                        >
                          <img
                            src={
                              promotion.promotion_banner_img_url === null ||
                                promotion.promotion_banner_img_url === ''
                                ? defaultBgPattern
                                : ImageHelper.getImageURL(
                                  promotion.promotion_banner_img_url,
                                  '?func=crop&w=400&h=300'
                                )
                            }
                            alt=""
                          />
                        </div>
                      ) : promotion.promotion_banner_type === 'custom' ? (
                        <div
                          className={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? `promotional-items__card default-bg hovernowshodow`
                              : 'promotional-items__card hovernowshodow'
                          }
                          key={promotion.id}
                        >
                          <img
                            src={
                              promotion.promotion_banner_img_url === null ||
                                promotion.promotion_banner_img_url === ''
                                ? defaultBgPattern
                                : ImageHelper.getImageURL(
                                  promotion.promotion_banner_img_url,
                                  '?func=crop&w=400&h=300'
                                )
                            }
                            alt=""
                          />
                          <div className="promotional-items__contents">
                            <div className="promotional-items__contents__data">
                              <h2 className={'promotional-items__contents__data__title'}>
                                {promotion.promotion_banner_title}
                              </h2>
                              <h3 className={'promotional-items__contents__data__sub-title'}>
                                {promotion.promotion_banner_sub_title}
                              </h3>
                            </div>
                          </div>
                        </div>
                      ) : promotion.promotion_banner_type === 'default' ? (
                        getDefaultTitleAndSubTitle(promotion.code.toUpperCase()).title ? (
                          <div
                            className={
                              promotion.promotion_banner_img_url === null ||
                                promotion.promotion_banner_img_url === ''
                                ? `promotional-items__card default-bg hovernowshodow`
                                : 'promotional-items__card hovernowshodow'
                            }
                            key={promotion.id}
                          >
                            <img
                              src={
                                promotion.promotion_banner_img_url === null ||
                                  promotion.promotion_banner_img_url === ''
                                  ? defaultBgPattern
                                  : ImageHelper.getImageURL(
                                    promotion.promotion_banner_img_url,
                                    '?func=crop&w=400&h=300'
                                  )
                              }
                              alt=""
                            />
                            <div className="promotional-items__contents">
                              <div className="promotional-items__contents__data">
                                <h2 className={'promotional-items__contents__data__title'}>
                                  {getDefaultTitleAndSubTitle(promotion.code.toUpperCase()).title}
                                </h2>
                                <h3 className={'promotional-items__contents__data__sub-title'}>
                                  {getDefaultTitleAndSubTitle(promotion.code.toUpperCase()).sub_title}
                                </h3>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ''
                        )
                      ) : (
                        <div
                          className={
                            promotion.promotion_banner_img_url === null ||
                              promotion.promotion_banner_img_url === ''
                              ? `promotional-items__card default-bg hovernowshodow`
                              : 'promotional-items__card hovernowshodow'
                          }
                          key={promotion.id}
                        >
                          <img
                            src={
                              promotion.promotion_banner_img_url === null ||
                                promotion.promotion_banner_img_url === ''
                                ? defaultBgPattern
                                : ImageHelper.getImageURL(
                                  promotion.promotion_banner_img_url,
                                  '?func=crop&w=400&h=300'
                                )
                            }
                            alt=""
                          />
                          <div className="promotional-items__contents">
                            <div className="promotional-items__contents__data">
                              <h2 className={'promotional-items__contents__data__title'}>
                                {promotion.promotion_banner_title}
                              </h2>
                              <h3 className={'promotional-items__contents__data__sub-title'}>
                                {promotion.promotion_banner_sub_title}
                              </h3>
                            </div>
                          </div>
                        </div>
                      )}
                    </SwiperSlide>
                  );
                })
              }
            </Swiper>
          </div>
        </>
      )}
      {promotionsList?.length === 0 && props._loyalties?.length > 0 && (
        <>
          <h4 class="f1 mb-2 custom-deals-name">PROMOS & REWARDS</h4>
          <div
            className={
              props.category_length === 1
                ? 'promotional-items promotional-item-without-category'
                : 'promotional-items'
            }
          >
            <Swiper
              // style={{display:"none"}}
              pagination={{
                clickable: true
              }}
              modules={promotionsList.length > 3 && [Pagination]}
              // breakpoints={promotionalBreakpoints}
              spaceBetween={getCurrentWidthSpaceBetween(props.currentWidth)}
              slidesPerView={getCurrentWidthViewPer(props.currentWidth)}
            >
              {props._loyalties.map((it, index) => {
                let loyaltyStats = recentCompletedStats(it, it.Reward.RewardLevels);
                let progress = it.loyalty_type === 1 ? loyaltyStats.stats.length / loyaltyStats.totalActions * 100 : loyaltyStats.stats.length !== 0 ? getSpendProgress(it, it.Reward.RewardLevels) / loyaltyStats.totalActions * 100 : 0;
                if (it.loyalty_type === 1 && it.Reward.reward_type === 0) {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);

                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b> Complete {activeRewardLevel.action} {activeRewardLevel.action === 1 ? 'visit' : 'visits'} {it.min_time_gap > 0 ? 'with ' + it.min_time_gap + ' hour interval' : ''}  </b> and get <a style={{ cursor: 'pointer' }} onClick={() => toggleRewardItemsModal(activeRewardLevel.RewardLevelData)}>{items(activeRewardLevel.RewardLevelData)}</a>
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>


                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.stats.length}</strong> out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.totalActions === 1 ? loyaltyStats.totalActions + ' Visit' : loyaltyStats.totalActions + ' Visits'}</strong>
                              </div>
                            </CircularProgressbarWithChildren>
                          }


                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"
                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :

                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'

                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )

                } else if (it.loyalty_type === 1 && it.Reward.reward_type === 1) {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);
                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b> Complete {activeRewardLevel.action} {activeRewardLevel.action === 1 ? 'visit' : 'visits'} {it.min_time_gap > 0 ? 'with ' + it.min_time_gap + ' hour interval' : ''}  </b> and get {activeRewardLevel.RewardLevelData[0].discount}% discount voucher
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>


                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.stats.length}</strong> out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{loyaltyStats.totalActions === 1 ? loyaltyStats.totalActions + ' Visit' : loyaltyStats.totalActions + ' Visits'}</strong>
                              </div>
                            </CircularProgressbarWithChildren>
                          }


                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"
                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :
                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'
                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )

                } else if (it.loyalty_type === 0 && it.Reward.reward_type === 1) {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);
                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b>Spend {ViewHelper.toCurrencyWithNoDecimal(activeRewardLevel.action, props._location.currency, 0)} </b> and get {activeRewardLevel.RewardLevelData[0].discount}% discount voucher
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>
                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(getSpendProgress(it, it.Reward.RewardLevels), props._location.currency, 0)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(loyaltyStats.totalActions, props._location.currency, 0)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                Spent
                              </div>
                            </CircularProgressbarWithChildren>
                          }

                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"
                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :

                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'
                              }

                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )

                } else {
                  let activeRewardLevel = getActiveRewardLevel(it.Reward.RewardLevels);
                  return (
                    <SwiperSlide>
                      <div className={`d-flex flex-row loyalty-items__card default-bg hovernowshodow`}>
                        <div className="loyalty-items__contents">
                          <div className='tint'></div>
                          <img
                            src={it.loyalty_img === null ||
                              it.loyalty_img === ''
                              ? defaultBgLoyaltyPattern
                              : ImageHelper.getImageURL(
                                it.loyalty_img,
                                '?func=crop&w=400&h=300'
                              )}
                            alt=""
                          />
                          <div className="loyalty-items__contents__data">
                            <h3 className={'loyalty-items__contents__data__sub-title'}>
                              <b>Spend {ViewHelper.toCurrencyWithNoDecimal(activeRewardLevel.action, props._location.currency, 0)} </b> and get {items(activeRewardLevel.RewardLevelData)}
                            </h3>
                            <a className='loyalty-menu-title' href={`${props._location.slug}/loyalty`}>View details</a>

                          </div>
                        </div>
                        <div className='d-flex flex-column justify-content-center circular-progress-alignment p-1' style={{ width: '45%' }}>
                          {progress >= 100 ?
                            <div className='d-flex justify-content-center'>
                              <img src={celebrating} className='loyalty-complete-img' />
                            </div>
                            :
                            <CircularProgressbarWithChildren value={progress}
                              strokeWidth={5}
                              styles={buildStyles({
                                pathColor: "#000",
                                textColor: "#000",
                              })} >
                              <div className='loyalty-progress-text'>
                                <strong> {ViewHelper.toCurrencyWithNoDecimal(getSpendProgress(it, it.Reward.RewardLevels), props._location.currency, 0)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                out of
                              </div>
                              <div className='loyalty-progress-text'>
                                <strong>{ViewHelper.toCurrencyWithNoDecimal(loyaltyStats.totalActions, props._location.currency, 0)}</strong>
                              </div>
                              <div className='loyalty-progress-text'>
                                Spent
                              </div>
                            </CircularProgressbarWithChildren>
                          }


                          <div className=" branding-btn mt-2 d-flex justify-content-center rounded-pill">
                            <div
                              className="branding-btn-font-color loyalty-menu-btn-font p-1"
                              style={{ fontSize: '10px' }}
                            >
                              {progress >= 100 ? <a style={{ cursor: 'pointer' }} className='branding-btn-font-color' href={`${props._location.slug}/earned`}>Check Rewards</a> :

                                TimeHelper.differenceFromNow(it.start_date) < 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                  'Expires in ' + calculateDaysRemaining(it.end_date)
                                  : TimeHelper.differenceFromNow(it.start_date) > 0 && TimeHelper.differenceFromNow(it.end_date) > 0 ?
                                    'Starts in ' + calculateDaysRemaining(it.start_date)
                                    :
                                    'Expired'
                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </SwiperSlide>
                  )
                }
              })
              }

            </Swiper>
          </div>
        </>
      )}
    </>
  );
};

function mapStateToProps(state) {
  const { promotions, loyalties } = state;
  return {
    promotions, _loyalties: loyalties

  };
}

export default connect(mapStateToProps, {})(withBackButtonHandled(PromotionalItems, (props) => { }));
